/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Paper, List } from '@material-ui/core';
import debounce from 'lodash/debounce';

export const SearchWithSuggestionContext = React.createContext({});

export const SearchWithSuggestionProvider = ({
  children,
  onSearch,
  searchBy,
  renderSuggestion,
  renderSuggestionItem,
  delay = 250,
}) => {
  const refInput = React.useRef();
  const [showSuggestion, setShowSuggestion] = React.useState(undefined);
  const [suggestions, setSuggestions] = React.useState([]);
  const [search, setSearch] = React.useState({
    searchBy,
    value: '',
  });
  React.useEffect(() => {
    setSearch({ ...search, searchBy });
  }, [searchBy]);

  const onChange = React.useCallback(
    debounce((newValue, options) => {
      setSearch({ ...search, value: newValue });
      onSearch({ ...search, value: newValue, ...options }, (newSuggestions) => {
        setSuggestions(newSuggestions);
      });
    }, delay),
    [onSearch]
  );

  const onFocus = () => {
    setTimeout(() => {
      setShowSuggestion(true);
    }, 150);
  };

  const onBlur = () => {
    setTimeout(() => {
      setShowSuggestion(false);
    }, 150);
  };

  const shouldShowSuggestion = React.useMemo(() => {
    if (showSuggestion === undefined) {
      return !!suggestions.length;
    }
    return showSuggestion && !!suggestions.length;
  }, [showSuggestion, suggestions]);

  return (
    <SearchWithSuggestionContext.Provider value={{ suggestions, onChange, setSuggestions }}>
      <Box position="relative">
        {children({ onChange, onBlur, onFocus, setSuggestions, suggestions, search, refInput })}
        {renderSuggestion
          ? renderSuggestion({ suggestions, renderSuggestionItem, refInput })
          : shouldShowSuggestion && (
              <Paper style={{ position: 'absolute', left: 0, right: 0, top: 60, zIndex: 10 }}>
                <List style={{ maxHeight: 250, overflow: 'auto' }}>
                  {suggestions.map((item) => renderSuggestionItem(item, refInput))}
                </List>
              </Paper>
            )}
      </Box>
    </SearchWithSuggestionContext.Provider>
  );
};
